function importAll(r) {
    return r.keys().map(r);
  }
  
  const UAE_H = importAll(require.context('../assets/photos/UAE_H', false, /\.(png|jpe?g|svg)$/));

  export default UAE_H;